import { useTranslation } from "react-i18next";
import type { CustomerTransferDeviceNotification } from "@/gql/graphql";
import DataListItemText from "@/components/app/Navigation/GlobalHeader/Notifications/Data/DataListItemText";

type CustomerDeviceTransferNotificationProps = {
  data: Pick<
    CustomerTransferDeviceNotification,
    "customerName" | "model" | "serialNumber"
  >;
};

const CustomerDeviceTransferNotification = (
  props: CustomerDeviceTransferNotificationProps
) => {
  const { data } = props;
  const { customerName, model, serialNumber } = data;
  const { t } = useTranslation();

  return (
    <DataListItemText
      primary={t("notifications.customer_device_transfer.title", {
        customerName: customerName ?? "",
        model: model ?? "",
      })}
      secondary={t("notifications.customer_device_transfer.description", {
        model: model ?? "",
        serialNumber,
      })}
    />
  );
};

export default CustomerDeviceTransferNotification;
